import { useEffect, useRef, useState } from 'react';
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
    PointElement,
    LineElement,
    Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { getConfigGrafica } from './config';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './grafica.module.scss';

ChartJS.register(ArcElement, Tooltip, Legend, Filler);

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const Grafica = (props) => {
    const { dades, tipus, chart, titol, subtitol, alcadaDefinida = true } = props;
    const [updateChart, setUpdateChart] = useState(1);
    const chartRef = useRef(null);
    const configs = getConfigGrafica(tipus, dades, alcadaDefinida);

    const dataSets = configs?.dataSets;
    const options = configs?.options;
    const labels = configs?.labels;

    const data = {
        labels: labels,
        datasets: dataSets
    };

    const stylesGrafica = clsx({
        [styles.grafica]: true,
        [styles[chart]]: !!chart,
        [styles.alcadaDefinida]: alcadaDefinida
    });

    const adjustChartHeight = () => {
        setUpdateChart((prev) => prev + 1);
    };

    useEffect(() => {
        adjustChartHeight();
        window.addEventListener('resize', adjustChartHeight);
        return () => window.removeEventListener('resize', adjustChartHeight);
    }, []);

    if (data.datasets.length > 0) {
        return (
            <div className={styles.contentGrafica}>
                <div className={styles.capcalera}>
                    {titol && <h3>{titol}</h3>}
                    {subtitol && <p>{subtitol}</p>}
                </div>

                <div className={stylesGrafica}>
                    {chart === 'line' && <Line ref={chartRef} options={options} data={data} redraw={true} />}
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export default Grafica;
